import { useQuery } from '@tanstack/react-query';
import { getTCRStateOptions } from 'services';
import { stateValues } from 'containers/pages/Messaging/CampaignDialog/constants';

export const useGetTCRStateOptions = () => {
  return useQuery(['getTCRStateOptions'], {
    queryFn: getTCRStateOptions,
    initialData: { usaStatesMap: stateValues },
    initialDataUpdatedAt: 0,
    select: (data) => {
      const values = Object.keys(data.usaStatesMap);
      const stateVals = values.map((value) => ({
        value,
        displayName: data.usaStatesMap[value],
      }));
      stateVals.sort((a, b) => a.displayName.localeCompare(b.displayName));
      return stateVals;
    },
  });
};
